// extracted by mini-css-extract-plugin
module.exports = {"budgetCurrency":"budget__currency-3d0","budgetError":"budget__error-4a0","positionCode":"position-code-9ac","displayFlex":"display-flex-778"};